/*  eslint-disable */

import NewDailyBulletinPlanningGrid from 'components/molecules/NewDailyBulletinPlanningGrid';
import NewDailyBulletinPlanningGridDetails from 'components/molecules/NewDailyBulletinPlanningGridDetails';

import {
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  TextFieldProps,
  TextField,
  Button,
} from '@mui/material';
import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { debounce } from 'lodash';
import FilterBarItem from 'components/molecules/FilterBarItem';
import { IFilterOptions } from 'interfaces/SelectOptions';
import { useDispatchFilter, useSelectFilter } from 'hooks/planning/useFilter';
import dayjs from 'dayjs';

import { useQuery } from 'react-query';
import { activityByExecutorAndTypes } from 'services/activity';
import { postPlanningGrid } from 'services/planning/grid';
import qs from 'qs';
import { IActivity, IData } from './types';
import useStyles from './styles';
import { IOption } from '../../molecules/ModalAddEquipment/types';
import { createFilterOptions } from '@material-ui/lab';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { removeSpecialChar } from 'helpers/removeSpecialChar';
import LoadingInputEndAdornment from 'components/atoms/LoadingInputEndAdornment';
import { postPlanningGridOutros } from 'services/planning/grid/planningGrid';

const TAKE = 1000;

interface ComboActivityProps {
  id: number;
  label: string;
  value: string;
  maintenanceType: string;
}

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const NewDailyBulletinPlanning = ({
  tag,
  idChecks,
  values,
  valueIdFornecedor,
  providerName,
  toggleState,
  valueIdFornecedorDiverse,
  tagCheckEquipment,
  equipmentList,
}: IActivity) => {
  const classes = useStyles();

  const [openDialogAddPlan, setOpenDialogAddPlan] = useState<boolean>(false);
  const [openDialogAddAtividade, setOpenDialogAddAtividade] = useState<boolean>(false);


  const inputFornecedorAdd = useRef<TextFieldProps>(null);
  const inputAtividadeAdd = useRef<TextFieldProps>(null);

  const [typeMaintenance, setTypeMaintenance] = useState('Preventiva');
  const [activity, setActivity] = useState<IData[]>([]);

  const [valueActivity, setValueActivity] = useState<IFilterOptions[]>([]);
  const [activityDiverse, setActivityDiverse] = useState<IFilterOptions[]>([]);

  const [currentPage] = useState<number>(0);

  const [pageSize, setPageSize] = useState<number>(TAKE);
  const [isLoading, setIsLoading] = useState(false);

  const [resultToGrid, setResultToGrid] = useState<any[]>([]);
  const [fornecedor, setFornecedor] = useState(valueIdFornecedor);

  
  const [fieldsSearchText, setFieldsSearchText] = useState<{
    [key: string]: string;
  }>({});

  const changeFilter = useDispatchFilter();
  const filterActivityRef: any = useRef(null);

  const toggleTypeMaintenance = event => {
    setTypeMaintenance(event.target.value);
  };

  const [inputFieldValues, setInputFieldValues] = useState<{
    [key: string]: string;
  }>({});

  //quando eu trocar de bop ou wtg ele apaga o valor que esta na atividade
  useEffect(() => {
    valueActivity.pop();
  }, [toggleState]);

  // percorre os item da atividade
  const option = activity.map(item => ({
    id: item.id,
    label:
      item.description +
      (toggleState !== 'OUTROS' ? ' - ' + item.maintenanceType : ''),
    value: `${item.id}-${item.description}-${item.maintenanceType}`,
    maintenanceType: item.maintenanceType,
  }));

  const initialOptions = useMemo(() => {
    return activity.map(item => ({
      id: item.id,
      label:
        item.description +
        (toggleState !== 'OUTROS' ? ' - ' + item.maintenanceType : ''),
      value: `${item.id}-${item.description}-${item.maintenanceType}`,
      maintenanceType: item.maintenanceType,
    }));
  }, [activity]);

  const [options, setOptions] = useState<ComboActivityProps[]>([]);

  const optionsInput: IOption[] = activity.map(item => ({
    value: `${item.id} - ${item.description} - ${item.maintenanceType}`,
    label: `${item.description} - ${item.maintenanceType}`,
  }));

  useEffect(() => {
    setOptions(initialOptions.sort((a, b) => a.label.localeCompare(b.label)));
  }, [initialOptions]);

  const [
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    planFilterOptionsContext,
    weekFilterOptionsContext,
    activityFilterOptionsContext,
    maintenanceTypeFilterOptionsContext,
    equipmentFilterOptionsContext,
    activityStatusFilterOptionsContext,
    indispFilterOptionsContext,
    supplierFilterOptionsContext,
  ] = [
    useSelectFilter('cluster'),
    useSelectFilter('installation'),
    useSelectFilter('plan'),
    useSelectFilter('week'),
    useSelectFilter('activity'),
    useSelectFilter('maintenance-type'),
    useSelectFilter('equipment'),
    useSelectFilter('activity-status'),
    useSelectFilter('indisp'),
    useSelectFilter('supplier'),
  ];
  const allFilterContextsBulletin = [
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    planFilterOptionsContext,
    weekFilterOptionsContext,
    activityFilterOptionsContext,
    maintenanceTypeFilterOptionsContext,
    equipmentFilterOptionsContext,
    activityStatusFilterOptionsContext,
    indispFilterOptionsContext,
    supplierFilterOptionsContext,
  ];

  const pauseFilterActivity = useMemo<boolean>(() => {
    return activityFilterOptionsContext.length > 0;
  }, [activityFilterOptionsContext]);

  const handleChanges = useCallback(
    ({ name, value }: { name: string; value: IFilterOptions[] }) => {
      changeFilter(name, value);
      setValueActivity(value);
    },

    [changeFilter],
  );

  const handleChangesDiverse = useCallback(
    ({ name, value }: { name: string; value: IFilterOptions[] }) => {
      setActivityDiverse(value);
    },
    [],
  );

  const AreaType = toggleState;
  const activityByExecutorAndTypesCall = useQuery({
    queryKey: [
      'activityFilterOptionsContext',
      [...allFilterContextsBulletin, inputFieldValues?.activity],
    ],
    queryFn: async () => {
      const params = {
        executorId:
          AreaType === 'OUTROS'
            ? '00'
            : valueIdFornecedor.toString().padStart(2, '0'),
        areaType: AreaType,
        maintenanceType:
          AreaType === 'OUTROS' ? 'OUTROS' : typeMaintenance.toUpperCase(),
        installationId: values[0]?.id,
      } as { [key: string]: (string | number)[] | string | number };

      if (
        inputFieldValues?.activity &&
        inputFieldValues?.activity.length >= 2
      ) {
        params.descriptionFilter = inputFieldValues?.activity;
      }

      const { data } = await activityByExecutorAndTypes(params);
      return data;
    },
    onSuccess: (data: IData[]) => {
      setActivity(data);
    },
    enabled: !pauseFilterActivity,
    cacheTime: 0,
  });

  useEffect(() => {
    if (valueIdFornecedor) setFornecedor(valueIdFornecedor);
    activityByExecutorAndTypesCall.refetch();
  }, [valueIdFornecedor, toggleState]);

  useEffect(() => {
    if (typeMaintenance) setTypeMaintenance(typeMaintenance);
    activityByExecutorAndTypesCall.refetch();
  }, [typeMaintenance.toUpperCase()]);

  const idAtividade = valueActivity.map(item =>
    Number(item.value.toString().split('-')[0]),
  );
  const nameAtividade = valueActivity.map(item => item.label);
  const maintenanceType = valueActivity.map(item => item.maintenanceType);

  useEffect(() => {
    setIsLoading(false);

    const fetchDataGrid = async () => {
      const qsparams = qs.stringify({
        page: currentPage + 1,
        take: pageSize,
      });

      const params = {
        activities: idAtividade,
        activityStatusIds: ['1', '3', '4', '5'],
        installationIds: installationFilterOptionsContext.map(item =>
          String(item?.value),
        ),
        equipmentIds: idChecks,
        clusterIds: [],
        maintenanceTypeIds:
          typeMaintenance === 'Preventiva' ? [2, 3, 4, 6] : [1, 5],
        plans: [],
        indisp: indispFilterOptionsContext.map(item => String(item?.value)),
        supplierExecutors: [],
        weeks: [],
        order: [],
      };
      if (idChecks.length > 0 || idAtividade.length > 0) {
        const { data } = await postPlanningGrid(qsparams, params);
        const resultData = data.result;
        setResultToGrid(resultData);
      }

      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    };
    if (idChecks.length === 0 && idAtividade.length === 0) {
      // fetchDataGrid();
      setResultToGrid([]);
    }

    fetchDataGrid();
  }, [valueActivity, idChecks, typeMaintenance]);


  useEffect(() => {
    const ids = activityDiverse.map(item =>
      Number(item.value.toString().split('-')[0]),
    );
    setIsLoading(false);
    const fetchDataGrid = async () => {
      const qsparams = qs.stringify({
        page: currentPage + 1,
        take: pageSize,
      });

      const params = {
        activityId: ids,
        activityStatusIds: ['1', '3', '5'], ///// ver status 4 - nao consta na documentacao
        installationIds: installationFilterOptionsContext.map(item =>
          Number(item?.value),
        ),
        equipmentIds: idChecks,
        clusterIds: [],
        providerId: [+fornecedor],
        maintenanceTypeIds: [],
        plans: [],
        indisp: indispFilterOptionsContext.map(item => String(item?.value)),
        supplierExecutors: [],
        weeks: [],
        order: [],
      };
      if (idChecks.length > 0 || ids.length > 0) {
        // setIsLoading(true);
        const { data } = await postPlanningGridOutros(qsparams, params);
        const resultData = data.result;
        setResultToGrid(resultData);
      }
    };

    if (idChecks.length === 0 && ids.length === 0) {
      setResultToGrid([]);
    }

    fetchDataGrid();
  }, [activityDiverse]);

  useEffect(() => {
    setIsLoading(false);
    const fetchDataGridOutros = async () => {
      const qsparams = qs.stringify({
        page: currentPage + 1,
        take: pageSize,
      });

      const params = {
        installationIds: installationFilterOptionsContext.map(item =>
          Number(item?.value),
        ),
        date: [],
        providerId: [+fornecedor],
        area: [],
        order: [],
        bulletinFlag: [],
        status: [1, 3, 5],
        week: [],
        plan: [],
        activityId: [],
        equipmentIds: [],
      };

      if (AreaType == 'OUTROS') {
        const { data } = await postPlanningGridOutros(qsparams, params);
        const resultData = data.result;
        setResultToGrid(resultData);
      }

      setIsLoading(false);
    };

    fetchDataGridOutros();
  }, [fornecedor]);

  useEffect(() => {
    setResultToGrid([]);
  }, [toggleState]);

  useEffect(() => {
    if (typeMaintenance) setTypeMaintenance(typeMaintenance);
    setResultToGrid([]);
  }, [typeMaintenance]);

  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 8);
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17);

  const diffInMs = end.getTime() - start.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60); // converte de milissegundos para horas

  const paramsNew: any = [
    {
      id: 0,
      activityPlanId: 0,
      startPrevBr: start,
      endPrevBr: end,

      completionPrev: end,
      outage: 'S',
      utilization: 'S',
      observationField: '',
      bulletinFlag: true,
      bulletinStatus: '',

      activitiesId: idAtividade,
      equipmentTag: tag,
      activityName: '',
      clusterId: values.map(item => item.id),
      providerName: providerName,
      completionPercentage: 0,
      planNumber: dayjs().year(),
      executor: valueIdFornecedor,

      activity: nameAtividade,
      installationId: values.map(item => item.id),
      instalationId: values.map(item => item.id),
      maintenance: maintenanceType,
      equipmentId: idChecks,
      equipment: tag ? tag : '',
      durationPrev: diffInHours,
    },
  ];

  const paramsNewDiverse: any = [
    {
      id: 0,
      start: start,
      completion: end,
      providerName: providerName,
      installationId: installationFilterOptionsContext.map(item =>
        Number(item?.value),
      ),
      instalationId: values.map(item => item.id),

      activityPlanId: 0,
      completionPrev: end,
      outage: 'N',
      utilization: 'N',
      observationField: '',
      bulletinFlag: true,
      bulletinStatus: '',

      activitiesId: '',
      equipmentTag: tag,
      activityName: '',
      clusterId: values.map(item => item.id),
      completionPercentage: 0,
      planNumber: dayjs().year(),
      executor: valueIdFornecedor,
      area: valueIdFornecedorDiverse,
      activity: activityDiverse,
      maintenance: maintenanceType,
      equipment: equipmentList,
      durationPrev: diffInHours,
    },
  ];

  const validationSchema = yup.object({
    description: yup.string(),
    location: yup.string().notRequired(),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: '',
      description: '',
    },
    validationSchema,
    onSubmit: formValues => {
      const formatedValues = {
        ...formValues,
        location: removeSpecialChar(`${formValues.location}`),
        description: removeSpecialChar(`${formValues.description}`),
      };
      let promise: Promise<unknown> = Promise.resolve();
    },
  });

  const handleAutoCompleteChange = useCallback(
    (name: string, option: IOption) => {
      const value = option?.value || '';
      formik.setFieldValue(name, value);
    },
    [formik],
  );

  const debouncesetInputFieldValues = useMemo(
    () =>
      debounce((name, value) => {
        setInputFieldValues(currentValues => ({
          ...currentValues,
          [name]: value,
        }));
      }, 600),
    [],
  );


  return (
    <div>
      <div className={classes.mainHeader}>
        {toggleState !== 'OUTROS' && (
          <>
            <div>
              <h3 className={classes.inputLabel}>Tipo de manutenção</h3>
              <ToggleButtonGroup
                color="primary"
                size="small"
                value={typeMaintenance}
                exclusive
                onChange={toggleTypeMaintenance}
                aria-label="Tipo de manutenção"
              >
                <ToggleButton value="Preventiva">Preventiva</ToggleButton>
                <ToggleButton value="Corretiva">Corretiva</ToggleButton>
              </ToggleButtonGroup>
            </div>
            <FormControl sx={{ ml: 1, flexGrow: 1 }}>
              <h3 className={classes.inputLabel}>Atividades</h3>
              <FilterBarItem
                options={options}
                onFilterChange={handleChanges}
                id="activity-filter"
                name="activity"
                label=""
                ref={filterActivityRef}
                setInputFieldValue={activity => {
                  debouncesetInputFieldValues('activity', activity);
                }}
                // initialState={planFilterOptionsContext}
                loading={false}
              />
            </FormControl>
          </>
        )}
        {toggleState === 'OUTROS' && (
          <>
            <FormControl sx={{ ml: 1, flexGrow: 1 }}>
              <h3 className={classes.inputLabel}>Atividades</h3>
              <FilterBarItem
                options={options}
                onFilterChange={handleChangesDiverse}
                id="supplier-filter"
                name="supplier"
                label=""
                ref={filterActivityRef}
                loading={false}
              />
            </FormControl>

            <div>
              <h3 className={classes.inputLabel} style={{ color: 'white' }}>
                .
              </h3>
              <Button
                variant="outlined"
                color="primary"
                className={`${classes.button} ${classes.leftButton}`}
                aria-label="outlined primary button"
                title="Adicionar nova Atividade"
                onClick={() => {
                  setOpenDialogAddAtividade(true);
                }}
              >
                <AddCircleOutlineOutlinedIcon />
              </Button>
            </div>

            <Dialog
              open={openDialogAddAtividade}
              onClose={() => {
                setOpenDialogAddAtividade(false);
              }}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle
                id="form-dialog-title"
                style={{ textAlign: 'center' }}
              >
                Digite o nome do nova Atividade
              </DialogTitle>
              <DialogContent>
                <TextField
                  id="txtObservacao"
                  label="Nova Atividade:"
                  inputRef={inputAtividadeAdd}
                  defaultValue=""
                  variant="outlined"
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialogAddAtividade(false);
                  }}
                  color="secondary"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    setOpenDialogAddAtividade(false);
                    const newOptions = [...option];
                    newOptions.push({
                      id: 0,
                      label: String(
                        inputAtividadeAdd.current?.value,
                      ).toUpperCase(),
                      value: '0 - ' + String(inputAtividadeAdd.current?.value),
                      maintenanceType: '',
                    });
                    setOptions(
                      newOptions.sort((a, b) => a.label.localeCompare(b.label)),
                    );
                  }}
                  color="primary"
                >
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openDialogAddPlan}
              onClose={() => {
                setOpenDialogAddPlan(false);
              }}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle
                id="form-dialog-title"
                style={{ textAlign: 'center' }}
              >
                Confirma a criação desse ítem no planejamento Diário?
              </DialogTitle>
              <DialogContent>
                <span>
                  <b>Instalação:</b> {inputFornecedorAdd.current?.value}
                </span>
                <span>
                  <b>Fornecedor:</b> {inputFornecedorAdd.current?.value}
                </span>
                <span>
                  <b>Área:</b> {inputFornecedorAdd.current?.value}
                </span>
                <span>
                  <b>Equipamento:</b> {inputFornecedorAdd.current?.value}
                </span>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenDialogAddPlan(false);
                  }}
                  color="secondary"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    setOpenDialogAddPlan(false);
                    const options: any = [];

                    optionsInput.map(item => {
                      options.push({
                        label: item.label,
                        value: item.value,
                      });
                    });

                    options.push({
                      label: inputFornecedorAdd.current?.value,
                      value: 0,
                    });

                    //setoptionsInput(options);
                  }}
                  color="primary"
                >
                  Confirmar Inclusão
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </div>
      {toggleState != 'OUTROS' && (
        <>
          <NewDailyBulletinPlanningGrid
            data={resultToGrid}
            params={paramsNew}
            toggleState={toggleState}
            isLoading={false}
          />
        </>
      )}
      {toggleState === 'OUTROS' && (
        <>
          <NewDailyBulletinPlanningGridDetails
            data={resultToGrid}
            params={paramsNewDiverse}
            toggleState={toggleState}
            isLoading={false}
          />
        </>
      )}
    </div>
  );
};

export default NewDailyBulletinPlanning;
